import axios from 'axios';

const baseURL = 'https://test3.m-direct.ru/';

const loginConfig = {
	baseURL,
	headers: {
		'Content-Type': 'application/json',
	},
}

export const LoginAPIInstance = axios.create(loginConfig);

const defaultConfig = {
	baseURL,
	headers: {
		'Content-Type': 'application/json',
	},
}

export const DefaultAPIInstance = axios.create(defaultConfig);
